export default __webpack_public_path__ + "static/media/csLogoMini.6e335b28.svg";